export const slugify = text =>
  text && text.replace(/[^\w]+/g, ' ').replace(/\s+/g, '-');
